import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_PROGRAM_PROMO_CODES_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS,
} from '@modules/affiliate-program-promo-codes/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type {
  IAffiliateProgramPromoCodeCreateResponse,
  IAffiliateProgramPromoCodePayload,
} from '../types';
import {
  AFFILIATE_PROGRAM_PROMO_CODES_CREATE_MUTATION_KEY,
  AFFILIATE_PROGRAM_PROMO_CODES_CREATE_URL,
} from '../constants';

export default function useAffiliateProgramPromoCodeCreateMutation(): IContextMutationResult<
  IAffiliateProgramPromoCodeCreateResponse,
  Error,
  IAffiliateProgramPromoCodePayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<IAffiliateProgramPromoCodeCreateResponse, Error, IAffiliateProgramPromoCodePayload>({
    mutationKey: [AFFILIATE_PROGRAM_PROMO_CODES_CREATE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<IAffiliateProgramPromoCodeCreateResponse>(
      AFFILIATE_PROGRAM_PROMO_CODES_CREATE_URL,
      payload,
      { permission: AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS.CREATE },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_PROGRAM_PROMO_CODES_LIST_QUERY_KEY] });
      displayPresetToast('created');
    },
  });
}
